export default "__VITE_ASSET__37KMUyue__"